/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { SlaSettingsResponse } from '../models/sla-settings-response';
import { SlaSettingsResponseDlmBaseResponse } from '../models/sla-settings-response-dlm-base-response';

@Injectable({
  providedIn: 'root',
})
export class SlaSettingsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiSlaSettingsSlaSettingsGet
   */
  static readonly ApiSlaSettingsSlaSettingsGetPath = '/api/SLASettings/SLASettings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSlaSettingsSlaSettingsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSlaSettingsSlaSettingsGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<SlaSettingsResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SlaSettingsService.ApiSlaSettingsSlaSettingsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SlaSettingsResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSlaSettingsSlaSettingsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSlaSettingsSlaSettingsGet$Plain(params?: {
  }): Observable<SlaSettingsResponseDlmBaseResponse> {

    return this.apiSlaSettingsSlaSettingsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SlaSettingsResponseDlmBaseResponse>) => r.body as SlaSettingsResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSlaSettingsSlaSettingsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSlaSettingsSlaSettingsGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<SlaSettingsResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SlaSettingsService.ApiSlaSettingsSlaSettingsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SlaSettingsResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSlaSettingsSlaSettingsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSlaSettingsSlaSettingsGet$Json(params?: {
  }): Observable<SlaSettingsResponseDlmBaseResponse> {

    return this.apiSlaSettingsSlaSettingsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SlaSettingsResponseDlmBaseResponse>) => r.body as SlaSettingsResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiSlaSettingsSlaSettingsPost
   */
  static readonly ApiSlaSettingsSlaSettingsPostPath = '/api/SLASettings/SLASettings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSlaSettingsSlaSettingsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSlaSettingsSlaSettingsPost$Plain$Response(params?: {
    body?: SlaSettingsResponse
  }): Observable<StrictHttpResponse<SlaSettingsResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SlaSettingsService.ApiSlaSettingsSlaSettingsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SlaSettingsResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSlaSettingsSlaSettingsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSlaSettingsSlaSettingsPost$Plain(params?: {
    body?: SlaSettingsResponse
  }): Observable<SlaSettingsResponseDlmBaseResponse> {

    return this.apiSlaSettingsSlaSettingsPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SlaSettingsResponseDlmBaseResponse>) => r.body as SlaSettingsResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSlaSettingsSlaSettingsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSlaSettingsSlaSettingsPost$Json$Response(params?: {
    body?: SlaSettingsResponse
  }): Observable<StrictHttpResponse<SlaSettingsResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SlaSettingsService.ApiSlaSettingsSlaSettingsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SlaSettingsResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSlaSettingsSlaSettingsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSlaSettingsSlaSettingsPost$Json(params?: {
    body?: SlaSettingsResponse
  }): Observable<SlaSettingsResponseDlmBaseResponse> {

    return this.apiSlaSettingsSlaSettingsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SlaSettingsResponseDlmBaseResponse>) => r.body as SlaSettingsResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiSlaSettingsEditSlaSettingsPost
   */
  static readonly ApiSlaSettingsEditSlaSettingsPostPath = '/api/SLASettings/edit-SLASettings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSlaSettingsEditSlaSettingsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSlaSettingsEditSlaSettingsPost$Plain$Response(params?: {
    body?: SlaSettingsResponse
  }): Observable<StrictHttpResponse<SlaSettingsResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SlaSettingsService.ApiSlaSettingsEditSlaSettingsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SlaSettingsResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSlaSettingsEditSlaSettingsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSlaSettingsEditSlaSettingsPost$Plain(params?: {
    body?: SlaSettingsResponse
  }): Observable<SlaSettingsResponseDlmBaseResponse> {

    return this.apiSlaSettingsEditSlaSettingsPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SlaSettingsResponseDlmBaseResponse>) => r.body as SlaSettingsResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSlaSettingsEditSlaSettingsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSlaSettingsEditSlaSettingsPost$Json$Response(params?: {
    body?: SlaSettingsResponse
  }): Observable<StrictHttpResponse<SlaSettingsResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SlaSettingsService.ApiSlaSettingsEditSlaSettingsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SlaSettingsResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSlaSettingsEditSlaSettingsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSlaSettingsEditSlaSettingsPost$Json(params?: {
    body?: SlaSettingsResponse
  }): Observable<SlaSettingsResponseDlmBaseResponse> {

    return this.apiSlaSettingsEditSlaSettingsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SlaSettingsResponseDlmBaseResponse>) => r.body as SlaSettingsResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiSlaSettingsDeleteSlaSettingsPost
   */
  static readonly ApiSlaSettingsDeleteSlaSettingsPostPath = '/api/SLASettings/delete-SLASettings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSlaSettingsDeleteSlaSettingsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSlaSettingsDeleteSlaSettingsPost$Plain$Response(params?: {
    body?: SlaSettingsResponse
  }): Observable<StrictHttpResponse<SlaSettingsResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SlaSettingsService.ApiSlaSettingsDeleteSlaSettingsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SlaSettingsResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSlaSettingsDeleteSlaSettingsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSlaSettingsDeleteSlaSettingsPost$Plain(params?: {
    body?: SlaSettingsResponse
  }): Observable<SlaSettingsResponseDlmBaseResponse> {

    return this.apiSlaSettingsDeleteSlaSettingsPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SlaSettingsResponseDlmBaseResponse>) => r.body as SlaSettingsResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSlaSettingsDeleteSlaSettingsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSlaSettingsDeleteSlaSettingsPost$Json$Response(params?: {
    body?: SlaSettingsResponse
  }): Observable<StrictHttpResponse<SlaSettingsResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SlaSettingsService.ApiSlaSettingsDeleteSlaSettingsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SlaSettingsResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiSlaSettingsDeleteSlaSettingsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiSlaSettingsDeleteSlaSettingsPost$Json(params?: {
    body?: SlaSettingsResponse
  }): Observable<SlaSettingsResponseDlmBaseResponse> {

    return this.apiSlaSettingsDeleteSlaSettingsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SlaSettingsResponseDlmBaseResponse>) => r.body as SlaSettingsResponseDlmBaseResponse)
    );
  }

}
